import { createSelector } from '@ngrx/store';
import { selectState } from '../../config/selectors';

const selectFeedbackPendings = createSelector(selectState, (state) => state?.pendings ?? null);

const selectFeedbackLearningPathPendings = createSelector(selectFeedbackPendings, (state) => state.learningPath?.paths ?? []);
const selectFeedbackLearningPathPendingsLoading = createSelector(selectFeedbackPendings, (state) => state.learningPath?.loading ?? null);
const selectFeedbackLearningPathPendingsDismissing = createSelector(selectFeedbackPendings, (state) => state.learningPath?.dismissing ?? null);

export { selectFeedbackLearningPathPendings, selectFeedbackLearningPathPendingsDismissing, selectFeedbackLearningPathPendingsLoading };
